export default __webpack_public_path__ + "de75dd16fffebfde46a99748cff6c961.svg";